import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  ProductOutputType,
} from '@/graphql/contracts/_generated_/contracts';
import {
  GetPaginatedFilteredProducts,
  GetPaginatedFilteredProductsVariables,
} from '@/graphql/contracts/_generated_/getPaginatedFilteredProducts.query';
import GetPaginatedProductsQuery from '@/graphql/contracts/getPaginatedFilteredProducts.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useGetProducts() {

  const [_getProducts, { data, loading }] = useLazyQuery<
  GetPaginatedFilteredProducts,
  GetPaginatedFilteredProductsVariables
  >(GetPaginatedProductsQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getProducts = async (params: GetPaginatedFilteredProductsVariables) => {
    const response = await _getProducts({
      variables: {
        ...params,
      }
    });

    const stockCodesWithAExcluded = response.data?.products?.items?.filter((e) => e?.stockCode &&
      !e.stockCode.endsWith('-A')) || [];

    return stockCodesWithAExcluded;
  };

  return {
    getProducts,
    isLoadingGetProducts: loading,
    products: (data?.products?.items ?? []) as ProductOutputType[]
  };
}
